import { render, staticRenderFns } from "./SopReport.vue?vue&type=template&id=84e31486"
import script from "./SopReport.vue?vue&type=script&lang=js"
export * from "./SopReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports